import moment from "moment-timezone";
import statsConfigs from "../../configs/stats";

const COLORS = ["#FEB787", "#5DCBD7", "#FD9295", "#6ED9BB", "#b49fdd", "#728caf", "#d2d67a"];

const COLORBYNAME = {
  AQUAFRESH: "#4097DA",
  POLIDENT: "#999999",
  SENSODYNE: "#051A68",
  PARODONTAX: "#C12F35"
};

/**
 * Returns the color from data's name/index
 * @param name
 * @param index
 * @return {String}
 */
export const idToColor = (name = "", index = 0) => {
  if (COLORBYNAME.hasOwnProperty(name)) {
    return COLORBYNAME[name];
  }

  return COLORS[Math.min(COLORS.length - 1, index)];
};

export const updateRankElements = (currentScore, elementsExtremeScores, nbElements) => {
  elementsExtremeScores = elementsExtremeScores || {};
  if (currentScore > elementsExtremeScores.first) {
    if (nbElements >= 6) {
      elementsExtremeScores.third = elementsExtremeScores.second;
      elementsExtremeScores.second = elementsExtremeScores.first;
    }
    elementsExtremeScores.first = currentScore;
  } else if (currentScore > elementsExtremeScores.second && nbElements >= 6) {
    elementsExtremeScores.third = elementsExtremeScores.second;
    elementsExtremeScores.second = currentScore;
  } else if (currentScore > elementsExtremeScores.third && nbElements >= 6) {
    elementsExtremeScores.third = currentScore;
  }
  if (currentScore < elementsExtremeScores.last) {
    if (nbElements >= 6) {
      elementsExtremeScores.thirdLast = elementsExtremeScores.secondLast;
      elementsExtremeScores.secondLast = elementsExtremeScores.last;
    }
    elementsExtremeScores.last = currentScore;
  } else if (currentScore < elementsExtremeScores.secondLast && nbElements >= 6) {
    elementsExtremeScores.thirdLast = elementsExtremeScores.secondLast;
    elementsExtremeScores.secondLast = currentScore;
  } else if (currentScore < elementsExtremeScores.thirdLast && nbElements >= 6) {
    elementsExtremeScores.thirdLast = currentScore;
  }
};

/**
 * Compare date to startDateRef
 * @param date
 * @return {Boolean}
 */
export const isStartDateRef = (date)=>{
  return moment(date).isSame(statsConfigs.startDateRef);
};



// WEBPACK FOOTER //
// src/modules/stats/utils.js